import { HelpCircle } from "lucide-react";
import { TeamBadgeDropdown } from "./TeamBadgeDropdown";

interface MemberBadgesProps {
  role?: string | null;
  team?: string | null;
}

export function MemberBadges({ role, team }: MemberBadgesProps) {
  return (
    <div className="flex items-center gap-4">
      {role && (
        <div className="inline-flex items-center gap-1">
          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-700">
            {role}
          </span>
          <a
            href="https://www.notion.so/comfy-org/Type-of-Team-Members-2506d73d3650808eb58ddba7d14756db?source=copy_link"
            target="_blank"
            rel="noopener noreferrer"
            className="text-stone-400 hover:text-stone-600 transition-colors"
            title="Learn about team member types"
          >
            <HelpCircle className="w-3 h-3" />
          </a>
        </div>
      )}
      {team && <TeamBadgeDropdown team={team} />}
    </div>
  );
}
